import ServiceIcon1 from "./service-icon.webp";
import ServiceIcon2 from "./service-icon-2.png";

import ContactGroupImage from "./contact-group-image.webp";
import Character from "./character-1.webp"

export { ServiceIcon1, ServiceIcon2 , ContactGroupImage, Character};
